import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ProductFamilyListComponent } from "./product-family-list/product-family-list.component";
import { ProductFamilyDetailComponent } from "./product-family-detail/product-family-detail.component";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const productFamiliesRoutes: Routes = [
  {
    path: "",
    component: ProductFamilyListComponent,
  },
  { path: "reset", redirectTo: "family", pathMatch: "prefix" },
  {
    path: "family",
    component: ProductFamilyDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "family/:id",
    component: ProductFamilyDetailComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(productFamiliesRoutes)],
  exports: [RouterModule],
})
export class ProductFamilyRoutingModule {}
